import * as types from "../actions/actionTypes";
const initialState = {
  modalStatus: false,
  modalData: {},

  data: [],
  loading: false,
  error: "",

  processing: false,

  ticketThreadLoading: false,
  ticketThreadError: "",
  ticketThread: {}
};

const Ticket = (state = initialState, action) => {
  switch (action.type) {
    case types.TICKET_LIST_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.TICKET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payLoad
      };
    case types.TICKET_LIST_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.TICKET_STORE_REQUEST:
      return { ...state, processing: true };
    case types.TICKET_STORE_SUCCESS:
      return { ...state, processing: false, modalStatus: false, modalData: {} };
    case types.TICKET_STORE_FAILURE:
      return { ...state, processing: false };

    case types.TICKET_UPDATE_REQUEST:
      return { ...state, processing: true };
    case types.TICKET_UPDATE_SUCCESS:
      return { ...state, processing: false, modalStatus: false, modalData: {} };
    case types.TICKET_UPDATE_FAILURE:
      return { ...state, processing: false };

    case types.TICKET_SHOW_REQUEST:
      return { ...state, ticketThreadLoading: true, ticketThreadError: "" };
    case types.TICKET_SHOW_SUCCESS:
      return {
        ...state,
        ticketThreadLoading: false,
        ticketThread: action.payLoad
      };
    case types.TICKET_SHOW_FAILURE:
      return {
        ...state,
        ticketThreadLoading: false,
        ticketThreadError: action.error
      };

    case types.TICKET_MODAL_DATA:
      return { ...state, modalStatus: true, modalData: action.data };
    case types.TICKET_CLOSE_MODAL:
      return { ...state, modalStatus: false, modalData: {} };
    default:
      return state;
  }
};

export default Ticket;
